export const comments = {
  edit: "Edit",
  delete: "Delete",
  reply: "Reply",
  anonymous: "Anonymous",
};
